module.exports = __webpack_public_path__ + "media/images/sales/weddingday/thumb-pricing-02-b94bf2f380b43d913868ceb499751c0d.svg";